var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCholesterolWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BoxContent/Header/LeftIcon3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BoxContent/Header/LeftIcon3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BoxContent/Header/LeftIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#fff",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.000000, 4.000000)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M7,12 C6.44771525,12 6,12.4477153 6,13 C6,13.5522847 6.44771525,14 7,14 C7.55228475,14 8,13.5522847 8,13 C8,12.4477153 7.55228475,12 7,12 Z M11,12 C10.4477153,12 10,12.4477153 10,13 C10,13.5522847 10.4477153,14 11,14 C11.5522847,14 12,13.5522847 12,13 C12,12.4477153 11.5522847,12 11,12 Z M4,11 C3.44771525,11 3,11.4477153 3,12 C3,12.5522847 3.44771525,13 4,13 C4.55228475,13 5,12.5522847 5,12 C5,11.4477153 4.55228475,11 4,11 Z M2,8 C1.44771525,8 1,8.44771525 1,9 C1,9.55228475 1.44771525,10 2,10 C2.55228475,10 3,9.55228475 3,9 C3,8.44771525 2.55228475,8 2,8 Z M5,8 C4.44771525,8 4,8.44771525 4,9 C4,9.55228475 4.44771525,10 5,10 C5.55228475,10 6,9.55228475 6,9 C6,8.44771525 5.55228475,8 5,8 Z M14,8 C13.4477153,8 13,8.44771525 13,9 C13,9.55228475 13.4477153,10 14,10 C14.5522847,10 15,9.55228475 15,9 C15,8.44771525 14.5522847,8 14,8 Z M3,5 C2.44771525,5 2,5.44771525 2,6 C2,6.55228475 2.44771525,7 3,7 C3.55228475,7 4,6.55228475 4,6 C4,5.44771525 3.55228475,5 3,5 Z M14,5 C13.4477153,5 13,5.44771525 13,6 C13,6.55228475 13.4477153,7 14,7 C14.5522847,7 15,6.55228475 15,6 C15,5.44771525 14.5522847,5 14,5 Z M4,3 C3.44771525,3 3,3.44771525 3,4 C3,4.55228475 3.44771525,5 4,5 C4.55228475,5 5,4.55228475 5,4 C5,3.44771525 4.55228475,3 4,3 Z M12,2 C11.4477153,2 11,2.44771525 11,3 C11,3.55228475 11.4477153,4 12,4 C12.5522847,4 13,3.55228475 13,3 C13,2.44771525 12.5522847,2 12,2 Z M9,1 C8.44771525,1 8,1.44771525 8,2 C8,2.55228475 8.44771525,3 9,3 C9.55228475,3 10,2.55228475 10,2 C10,1.44771525 9.55228475,1 9,1 Z",
    id: "Combined-Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCholesterolWhite);
export default __webpack_public_path__ + "static/media/icon-cholesterol-white.deccb14259732c8dce5bc7cb510cb4e3.svg";
export { ForwardRef as ReactComponent };